export enum LayoutLocation{
    Left=1,
    Right=2,
    Center=3,
}